window.addEventListener("DOMContentLoaded", function () {
  const anchorsBanner = document.querySelector(".anchors-banner");
  const sections = document.querySelectorAll("*[id]");
  const anchorsLinks = document.querySelectorAll(
    ".anchors-banner__links .link"
  );
  const hasOffset = window.scrollY !== undefined;
  const docBody =
    document.documentElement || document.body.parentNode || document.body;
  let scrollTop = hasOffset ? window.scrollY : docBody.scrollTop;
  let stop;
  let carousel;

  function checkBannerVisibility() {
    if (scrollTop >= stop) {
      anchorsBanner.classList.add("is-sticky");
    } else {
      anchorsBanner.classList.remove("is-sticky");
    }
  }

  if (0 < anchorsLinks.length && 0 < sections.length) {
    stop = anchorsBanner.offsetTop + 200;
    checkBannerVisibility();

    carousel = new Swiper(".anchors-banner__carousel", {
      slidesPerView: "auto",
      watchOverflow: true,
    });

    window.addEventListener("scroll", function () {
      scrollTop = hasOffset ? window.scrollY : docBody.scrollTop;
      checkBannerVisibility();
    });
  }
});
